// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607201412/js/" + chunkId + "." + {"44":"8a2e6406","225":"34857752","481":"76b171de","486":"366e410f","770":"4262714e"}[chunkId] + ".0.7281933429661769.chunk.js";
};